module.exports = __webpack_public_path__ + "img/phone.6983ac28.png";